import { lazy } from "react";
import { Route } from "../../RouteModel";

const CustomerAddressCreate = lazy(
  () => import("./../../../pages/configuration/customers/address/Create")
);
const CustomerAddressEdit = lazy(
  () => import("./../../../pages/configuration/customers/address/Edit")
);

export const customerAddressRoutes: Route[] = [
  {
    i18nName: "Address create",
    path: "/configuration/customers/:id/address/create",
    component: CustomerAddressCreate,
  },
  {
    i18nName: "Address edit",
    path: "/configuration/customers/:id/address/edit",
    component: CustomerAddressEdit,
  },
];
